import PropFirmMonthRecap from "../../../prop-firm-manager/PropFirmMonthRecap";
import { usePfmData } from "../../../prop-firm-manager/PfmDataContext";

export default function PropFirmMonthRecapWidget() {
  const { calendarEvents, calendarMonth } = usePfmData();
  return (
    <div className="h-full overflow-auto">
      <PropFirmMonthRecap events={calendarEvents} currentMonth={calendarMonth} />
    </div>
  );
}
